module.exports = __webpack_public_path__ + "static/media/crypto-transaction.fce507c9.png";